<div class="relative h-screen flex flex-col gap-2 bg-mbaza-gray-very-light" *transloco="let t">
  <div
    class="h-full bg-gradient-to-r from-mbaza-primary/85 to-mbaza-secondary/85 flex justify-center items-center rounded-sm">
    <div
      class="absolute inset-0 opacity-30 before:absolute before:inset-0 before:bg-[radial-gradient(circle,white_2px,transparent_2px)] before:bg-[length:30px_30px]">
    </div>
    <div class="w-full flex justify-center items-center">
      <section
        class="flex flex-col justify-center items-center px-6 py-9 lg:p-12 lg:px-0 w-11/12 md:w-8/12 lg:w-7/12 xl:w-4/12 2xl:w-4/12 rounded-sm lg:rounded-none lg:h-full bg-white backdrop-blur-sm">
        <div class="flex justify-center items-center w-full">
          <app-mb-logo size="large" class="mb-2 sm:mb-4 md:mb-6" />
        </div>
        <div class="flex flex-col justify-center mb-2">
          <span class="text-center text-xl font-black 2xl:text-3xl">{{ t('resetPassword') }}</span>
        </div>

        @if (isResetPassword) {
        <div class="w-full px-6 md:px-12 py-9">
          <form [formGroup]="resetPasswordForm" class="flex flex-col gap-4 w-full">
            <app-mb-input [placeholder]="t('enterCode')" formControlName="code" [prefixLabel]="t('code')"
              [errorMessage]="zodErrors['code']" [hasError]="!!zodErrors['code']" />
            <app-mb-input [placeholder]="t('enterNewPassword')" formControlName="newPassword"
              [prefixLabel]="t('newPassword')" type="password" [errorMessage]="zodErrors['newPassword']"
              [hasError]="!!zodErrors['newPassword']" />
            <app-mb-button type="primary" class="w-full" [label]="t('confirmPasswordReset')"
              [loading]="isResettingPassword" (clickHandler)="resetPassword()" />
            <app-language-switcher />
          </form>
        </div>
        } @else {
        <div class="w-full px-6 md:px-12 py-9">
          <form [formGroup]="requestResetPasswordForm" class="flex flex-col gap-4 w-full">
            <app-mb-input [placeholder]="t('enterEmailOrPhoneNumber')" formControlName="identifier"
              [prefixLabel]="t('emailOrPhone')" [errorMessage]="zodErrors['identifier']"
              [hasError]="!!zodErrors['identifier']" />
            <app-mb-button type="primary" class="w-full" [label]="t('resetPassword')"
              [loading]="isRequestingReset" (clickHandler)="requestPasswordReset()" />
            <app-mb-button [label]="t('goToLogin')" [type]="'ghost'" [disabled]="isRequestingReset"
              (clickHandler)="navigateToLogin()" class="w-full" [attr.aria-label]="t('goToLogin')" />
            <app-language-switcher />
          </form>
        </div>
        }
      </section>
    </div>
  </div>
</div>
